import { render, staticRenderFns } from "./StatusTableau.vue?vue&type=template&id=2dfbecca&scoped=true&xmlns%3Av-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./StatusTableau.vue?vue&type=script&lang=js"
export * from "./StatusTableau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbecca",
  null
  
)

export default component.exports